const index = "dashboard";

export const dashboardEndpoint = Object.freeze({
  dashboard: index,
  sidebar: `${index}/sidebar`,
});
